import React, { Activity } from 'react';
import cn from 'clsx';
import styles from './styles.module.scss';
import Card from '@components-clean/core/card';
import { FilterActions } from '@components-clean/core/filter-ui/action-bar/filter/filter-actions';
import { IFeActionsBarProps } from '@components-clean/core/filter-ui/action-bar/shared/interfaces';

const FeActionsBar = ({
    filterActions,
    className,
    headerExtra,
    initialTrackedChanges,
    initialExactMatch,
    onTrackedChangesChange,
}: IFeActionsBarProps) => {
    return (
        <Card
            data-testid="fe-grid-action-bar"
            className={cn('actions-bar', className, styles.actionBar)}
            padding="none"
        >
            <div className="k-d-flex k-w-full" style={{ gap: '14px' }}>
                <Activity mode={filterActions ? 'visible' : 'hidden'}>
                    <div className="k-d-flex k-justify-content-between k-w-full k-gap-1">
                        <FilterActions
                            headerExtra={headerExtra}
                            initialTrackedChanges={initialTrackedChanges}
                            initialExactMatch={initialExactMatch}
                            onTrackedChangesChange={onTrackedChangesChange}
                        />
                    </div>
                </Activity>
            </div>
        </Card>
    );
};

export default FeActionsBar;
